<cc-box>
  <div class="lg-container" box header>{{title}}</div>
  <div box content>
    <div ace-editor
         [(text)]="content"
         [(mode)]="mode"
         [theme]="'solarized_dark'"
         [options]="{printMargin: false}"
         [readOnly]="false"
         [autoUpdateContent]="true"
         (textChanged)="onChange($event)"
         class="ace-editor"
         #editor>
    </div>
  </div>
</cc-box>
